import proto from '../../protocol'
import store from './store'
import {
    GET_CHANNEL,
    GET_SELECTED_CHANNEL,
} from '../gettersTypes'
import {
    ACT_HANDLE_TOKENS_EVENT,
    ACT_HANDLE_CHANNEL_CHANGE_EVENT,
    ACT_UPDATE_TA,
    ACT_HIDE_INCOMMING_CALL,
    ACT_UPDATE_CALLS,
    ACT_UPDATE_CALL,
    ACT_HANDLE_MESSAGE_EVENT,
    ACT_HANDLE_MESSAGE_CHANGE_EVENT,
    ACT_HANDLE_MESSAGE_UPDATE_EVENT,
    ACT_HANDLE_MESSAGE_REACTION_EVENT,
    ACT_UPDATE_CHAT,
    ACT_EVENT_PHONE,
    ACT_CONF_LIST_UPDATE_ASSISTANT,
    ACT_HANDLE_ROLES_REVISION_EVENT,
    ACT_HANDLE_CONTACT_CONNECTION_CHANGE_EVENT,
    ACT_HANDLE_CONTACT_CHANGE_EVENT,
    ACT_HANDLE_HISTORY_CALL_CHANGE_EVENT,
    ACT_HANDLE_HISTORY_CALL_EVENT,
    ACT_SET_USER_PROFILE,
    ACT_HANDLE_FAVOURITES_EVENT,
    ACT_PHONE_RTC_CALL_HANDLE_API_CALLS_EVENT,
    ACT_HANDLE_COMMENT_SUBSCRIBED_EVENT,
    ACT_HANDLE_COMMENT_EVENT,
    ACT_HANDLE_COMMENT_REACTION_EVENT,
    ACT_HANDLE_COMMENT_UPDATE_EVENT,
    ACT_HANDLE_COMMENT_CHANGE_EVENT,
    ACT_SOCKET_HANDLE_CONFIG_RECEIVED,
    ACT_SOCKET_HANDLE_STATUS_CHANGED,
    ACT_NOTIFY_NEW_ADD,
    ACT_TASKS_HANDLE_TASK_CHANGE,
} from '../actionsTypes'

import {
    LOGIN,
    CONTACTS,
    CHANNELS,
    PHONE_CNTL,
    ASISTANTS,
    CHATS,
    PHONE,
    SOCKET,
    CALLS,
    USERPROFILE,
    NOTIFICATIONS_NEW,
    TASKS,
} from '../modulesNames'

import event_bus from "../../eventBus"
import {NOTIFY_DATA_TYPES} from '../modules/notificationsNew'

proto.on('config-received', config => {
    store.dispatch(`${SOCKET}/${ACT_SOCKET_HANDLE_CONFIG_RECEIVED}`, config)
})

proto.on('state-changed', (payload) => {
    store.dispatch(`${SOCKET}/${ACT_SOCKET_HANDLE_STATUS_CHANGED}`, payload)
})

proto.on('qr-login-data-event', data => {
    event_bus.$emit(data)
})

proto.on('tokens-event', (payload) => {
    store.dispatch(`${LOGIN}/${ACT_HANDLE_TOKENS_EVENT}`, payload)
})

proto.on('profile-event', (payload) => {
    store.dispatch(`${USERPROFILE}/${ACT_SET_USER_PROFILE}`, payload)
})

proto.on('favorites-change-event', (payload) => {
    store.dispatch(`${CONTACTS}/${ACT_HANDLE_FAVOURITES_EVENT}`, payload)
})

proto.on('role-revision-change-event', (payload) => {
    store.dispatch('contacts/changeRolesRevisionEvent', payload)
})

proto.on('contact-change-event', ({type, data}) => {
    const {type: eventType, contact, cid} = data
    store.dispatch(`${CONTACTS}/${ACT_HANDLE_CONTACT_CHANGE_EVENT}`, {eventType, contact, cid, type})
});

proto.on('role-revision-change-event', (payload) => {
    store.dispatch(`${CONTACTS}/${ACT_HANDLE_ROLES_REVISION_EVENT}`, payload)
})

proto.on('contact-connection-change-event', (payload) => {
    store.dispatch(`${CONTACTS}/${ACT_HANDLE_CONTACT_CONNECTION_CHANGE_EVENT}`, payload)
})

proto.on('channel-change-event', (payload) => {
    store.dispatch(`${CHANNELS}/${ACT_HANDLE_CHANNEL_CHANGE_EVENT}`, payload)
});

proto.on('publication-event', async data => {
    const { chId, pubId, title } = data
    await store.dispatch('channel/updatePublication', { chId, pubId })
    store.commit('channels/updateChannelLastTitle', { chId, text: title })
    if (store.getters[`${CHANNELS}/${GET_SELECTED_CHANNEL}`] === chId) store.dispatch('channels/watchChannelPublications', { chId })
    const channel = store.getters[`${CHANNELS}/${GET_CHANNEL}`]({chId})
    const isMuted = channel && channel.settings && channel.settings.mute > date_helper.getCurrentUnixTime()
    if (!isMuted) store.dispatch(`${NOTIFICATIONS_NEW}/${ACT_NOTIFY_NEW_ADD}`, { type: NOTIFY_DATA_TYPES.PUBLICATION, payload: data }, {root: true})
})

proto.on('delete-publication-event', data => {
    const { chId, pubId } = data
    store.commit('channel/removePublication', { chId, pubId })
})

// --------- ASISTANTS ------------------

proto.on('assistant-ta-info-event', (data) => {
    const theme = store.getters['clientdata/getTheme']
    data.theme = theme
    store.dispatch(`${ASISTANTS}/${ACT_UPDATE_TA}`, data)
})
proto.on('assistant-calls-info-event', (data) => {
    store.dispatch(`${ASISTANTS}/${ACT_UPDATE_CALLS}`, data)
})
proto.on('assistant-call-info-event', (data) => {
    store.dispatch(`${ASISTANTS}/${ACT_UPDATE_CALL}`, data)
})
proto.on('assistant-conference-event', (data) => {
    store.dispatch(`${ASISTANTS}/${ACT_CONF_LIST_UPDATE_ASSISTANT}`, data)
})

// -------- CALLS -----------------------

proto.on('rtc-call-event', (data) => {
    store.dispatch(`${PHONE}/${ACT_PHONE_RTC_CALL_HANDLE_API_CALLS_EVENT}`, data)
})
proto.on('rtc-call-termination-event', (data) => {
    store.dispatch(`${PHONE}/${ACT_EVENT_PHONE}`, { data, eventName: 'rtc-call-termination-event' })
    store.dispatch(`${PHONE_CNTL}/${ACT_HIDE_INCOMMING_CALL}`, { type: 'phone', id: data.callId })
})
proto.on('rtc-call-conference-event', (data) => {
    store.dispatch(`${PHONE}/${ACT_EVENT_PHONE}`, {eventName: 'rtc-call-conference-event', data})
})
proto.on('history-call-event', data => {
    store.dispatch(`${CALLS}/${ACT_HANDLE_HISTORY_CALL_EVENT}`, data)
})
proto.on('history-call-change-event', data => {
    store.dispatch(`${CALLS}/${ACT_HANDLE_HISTORY_CALL_CHANGE_EVENT}`, data)
})
proto.on('rtc-call-ringing-event', data => {
    store.dispatch(`${PHONE}/${ACT_EVENT_PHONE}`, { data: data, eventName: 'rtc-call-ringing-event' })
})
proto.on('rtc-call-answer-event', data => {
    store.dispatch(`${PHONE}/${ACT_EVENT_PHONE}`, { data: data, eventName: 'rtc-call-answer-event' })
})
proto.on('rtc-call-processing-event', data => {
    store.dispatch(`${PHONE}/${ACT_EVENT_PHONE}`, { data: data, eventName: 'rtc-call-processing-event' })
})
proto.on('rtc-call-options-event', data => {
    store.dispatch(`${PHONE}/${ACT_EVENT_PHONE}`, { data: data, eventName: 'rtc-call-options-event' })
})

// --------- CHATS ------------------

proto.on('chat-change-event', (payload) => {
    store.dispatch(`${CHATS}/${ACT_UPDATE_CHAT}`, payload)
})

proto.on('message-event', (payload) => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_MESSAGE_EVENT}`, payload)
})

proto.on('message-change-event', payload => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_MESSAGE_CHANGE_EVENT}`, payload)
})

proto.on('message-update-event', payload => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_MESSAGE_UPDATE_EVENT}`, payload)
})

proto.on('message-reaction-event', payload => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_MESSAGE_REACTION_EVENT}`, payload)
})

proto.on('set-chat-keyboard', payload => {
    store.commit('chats/updateKeyboard', payload)
})

proto.on('message-comment-subscribed-event', payload => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_COMMENT_SUBSCRIBED_EVENT}`, payload)
})

proto.on('message-comment-event', payload => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_COMMENT_EVENT}`, payload)
})

proto.on('message-comment-reaction-event', payload => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_COMMENT_REACTION_EVENT}`, payload)
})

proto.on('message-comment-update-event', payload => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_COMMENT_UPDATE_EVENT}`, payload)
})

proto.on('message-comment-change-event', payload => {
    store.dispatch(`${CHATS}/${ACT_HANDLE_COMMENT_CHANGE_EVENT}`, payload)
})

// --------- TASKS ------------------

proto.on('deferred-task-change-event', (payload) => {
    store.dispatch(`${TASKS}/${ACT_TASKS_HANDLE_TASK_CHANGE}`, payload)
})